import React, { useEffect, useState, useRef } from 'react'
import TopHeader from './top-header'
import NavItem from './nav-item'
import NavDropdown from './nav-dropdown'
import AppLogo from './app-logo'
import HomeIcon from 'icon/home'
import ScanIcon from 'icon/scanIcon'
import SpeakerIcon from 'icon/speaker'
import ChartIcon from 'icon/chart'
import WebhookIcon from 'icon/webhookicon'
import BroadcastIcon from 'icon/broadcasticon'
import StarIcon from 'icon/staricon'
import CampaignsIcon from 'icon/campaigns'
import { PREMIUM_APPS } from 'enums'
import ChatIcon from 'icon/chatIcon'
import TicketIcon from 'icon/ticketIcon'
import { useAgency } from 'context/agency'
import GraphIcon from 'icon/graph'
import BasicinfoIcon from 'icon/basicinfo'
import TeamIcon from 'icon/team'
import LocationIcon from 'icon/locationicon'
import KeyIcon2 from 'icon/key'
import LinkIcon from 'icon/link'
import BillIcon from 'icon/bill'
import ButtonGradient from 'component/Buttons/dashboard-btn'
import SideNAvButtonGradient from 'component/Buttons/sidenav-btn'
import { useNavigate } from 'react-router-dom'
import GiftIcon from 'icon/gift'
import WalletIcon from 'icon/walleticon'
import SnapshotIcon from 'icon/SnapshotIcon'
import { useLocationInfo } from 'context/location'
import { useSSO } from 'context/sso'

const premiumAppsNavItem = {
  [PREMIUM_APPS.chat]: {
    label: 'Chat',
    path: './settings/chat',
    icon: <ChatIcon />,
  },
  [PREMIUM_APPS.ticket]: {
    label: 'Ticket',
    path: './settings/ticket',
    icon: <TicketIcon />,
  },
  [PREMIUM_APPS.citypass]: {
    label: 'CityPass',
    path: './settings/citypass',
    icon: <SpeakerIcon />,
  },
}

const menu = [
  {
    label: 'Home',
    path: './home',
    icon: <HomeIcon />,
  },
  {
    label: 'Dashboard',
    path: './dashboard',
    icon: <GraphIcon />,
  },
  {
    label: 'Campaigns',
    path: './campaigns',
    icon: <CampaignsIcon />,
    key: 'campaign',
  },
  {
    label: 'Reward',
    path: './reward',
    icon: <GiftIcon />,
    key: 'rewards',
  },
  {
    label: 'GrowthTool',
    path: './growthtool',
    icon: <ChartIcon />,
  },
  {
    label: 'Customers',
    path: './customers',
    icon: <StarIcon />,
    key: 'customer',
  },
  {
    label: 'Scanner',
    path: './scanner',
    icon: <ScanIcon />,
    key: 'scanner',
  },
  {
    label: 'BroadCast',
    path: './broadcast',
    icon: <BroadcastIcon />,
  },
  {
    label: 'Webhook',
    path: './webhook',
    icon: <WebhookIcon />,
  },
  {
    label: 'Wallet App',
    path: './wallet',
    icon: <WalletIcon />,
    key: 'walletapp',
  },
]

const settings = [
  {
    label: 'General Info',
    path: './settings/generalinfo',
    icon: <BasicinfoIcon />,
  },
  {
    label: 'Team',
    path: './settings/team',
    icon: <TeamIcon />,
  },
  {
    label: 'Geo Locations',
    path: './settings/geo-location',
    icon: <LocationIcon />,
  },
  {
    label: 'ApiKey',
    path: './settings/apikey',
    icon: <KeyIcon2 />,
  },
  {
    label: 'Integration',
    path: './settings/integration',
    icon: <LinkIcon />,
  },
  {
    label: 'Agency Info',
    path: './settings/agencyinfo',
    icon: <BasicinfoIcon />,
  },
  {
    label: 'Snapshot',
    path: './settings/snapshot',
    icon: <SnapshotIcon />,
  },
]

function Topbar({ className }) {
  const { agency } = useAgency()
  const { saasPlan } = useLocationInfo()
  const [openSideMenu, setOpenSideMenu] = useState(false)
  const [showSettings, setShowSettings] = useState(
    window.location.pathname.includes('settings')
  )
  const { sso } = useSSO()
  const [filteredMenu, setFilteredMenu] = useState(menu)
  const navigate = useNavigate()
  const sidenav_bg_color = agency.location_config?.sidenav_bg_color
  const page_color = agency.location_config?.page_bg_color
  const s_text_color = agency.location_config?.sidenav_text_color
  const [showMoreDropdown, setShowMoreDropdown] = useState(false)
  const moreButtonRef = useRef(null)

  if (!sso) {
    settings.push({
      label: 'Billing',
      path: './settings/billings',
      icon: <BillIcon />,
    })
  }

  const isAppExist = (app) =>
    agency.premium_apps?.find((item) => item.upsale_id?.products?.includes(app))

  const getPremiumApps = () => {
    const apps = []
    if (isAppExist(PREMIUM_APPS.citypass))
      apps.push(premiumAppsNavItem[PREMIUM_APPS.citypass])
    if (isAppExist(PREMIUM_APPS.chat))
      apps.push(premiumAppsNavItem[PREMIUM_APPS.chat])
    if (isAppExist(PREMIUM_APPS.ticket))
      apps.push(premiumAppsNavItem[PREMIUM_APPS.ticket])
    return apps
  }

  const renderItem = (menu_item, index) => (
    <div key={`${menu_item.label}-${index}`}>
      {menu_item.children ? (
        <NavDropdown {...menu_item} />
      ) : (
        <NavItem
          {...menu_item}
          active={window.location.pathname === menu_item.path}
        />
      )}
    </div>
  )

  useEffect(() => {
    if (saasPlan?.features?.length) {
      const filtered = menu.filter((item) =>
        saasPlan.features.find((key) => key.includes(item.key))
      )
      setFilteredMenu(filtered)
    }
  }, [saasPlan])

  // Determine visible tabs and overflow tabs
  const maxVisibleTabs = 7 // Adjust based on typical screen width and tab size
  const currentMenu = showSettings
    ? [...settings, ...getPremiumApps()]
    : filteredMenu
  const visibleTabs = currentMenu.slice(0, maxVisibleTabs)
  const overflowTabs = currentMenu.slice(maxVisibleTabs)

  // Handle clicks outside the More dropdown to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        moreButtonRef.current &&
        !moreButtonRef.current.contains(event.target)
      ) {
        setShowMoreDropdown(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div className={className}>
      <nav
        style={{ backgroundColor: page_color }}
        className='fixed w-full top-0 z-50'
      >
        <div className='bg-white border-b border-gray-200 rounded-b-3xl'>
          <div className='px-3 py-3 flex items-center justify-between'>
            <button
              type='button'
              className='inline-flex items-center p-2 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200'
              onClick={() => setOpenSideMenu(!openSideMenu)}
            >
              <span className='sr-only'>Open menu</span>
              <svg
                className='w-6 h-6'
                aria-hidden='true'
                fill='currentColor'
                viewBox='0 0 20 20'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  clipRule='evenodd'
                  fillRule='evenodd'
                  d='M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z'
                />
              </svg>
            </button>
            <aside
              style={{ backgroundColor: sidenav_bg_color }}
              className={`w-full transition-transform ${
                openSideMenu ? 'transform-none' : 'hidden sm:block'
              }`}
            >
              <div
                className={`px-3 py-4 flex items-center justify-between ${
                  sidenav_bg_color ? '' : 'bg-white'
                }`}
              >
                <ul className='flex items-center gap-2 font-medium'>
                  {visibleTabs.map((menu_item, index) =>
                    renderItem(menu_item, index)
                  )}
                  {overflowTabs.length > 0 && (
                    <li className='relative' ref={moreButtonRef}>
                      <button
                        type='button'
                        className='flex items-center p-2 text-sm text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200'
                        onClick={() => setShowMoreDropdown(!showMoreDropdown)}
                      >
                        <span className='text-lg'>...</span>
                      </button>
                      {showMoreDropdown && (
                        <ul className='absolute z-50 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg'>
                          {overflowTabs.map((menu_item, index) => (
                            <li key={`${menu_item.label}-${index}`}>
                              <NavItem
                                {...menu_item}
                                active={
                                  window.location.pathname === menu_item.path
                                }
                                className='w-full text-left px-4 py-2 hover:bg-gray-100'
                              />
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  )}
                  {showSettings && getPremiumApps().length ? (
                    <li className='flex items-center'>
                      <div
                        className='text-xs absolute top-0 rounded-full bg-yellow-400 px-2 py-1'
                        style={{ color: s_text_color }}
                      >
                        Premium
                      </div>
                    </li>
                  ) : null}
                </ul>
                <div className='ml-auto'>
                  {showSettings ? (
                    <SideNAvButtonGradient
                      type='button'
                      onClick={() => {
                        setShowSettings(false)
                        navigate('/')
                      }}
                      className='px-4 py-2'
                    >
                      Go Back
                    </SideNAvButtonGradient>
                  ) : (
                    <SideNAvButtonGradient
                      type='button'
                      onClick={() => {
                        setShowSettings(true)
                        navigate('./settings/')
                      }}
                      className='px-4 py-2'
                    >
                      Settings
                    </SideNAvButtonGradient>
                  )}
                </div>
              </div>
            </aside>
            <TopHeader />
          </div>
        </div>
      </nav>
    </div>
  )
}

export default Topbar
